import { Box, Typography } from '@mui/material';
import { TournamentEntity } from 'app/interfaces/entity';
import { MyTeamPlayersList } from 'modules/tournaments/components/BracketTournament/MyTeam/MyTeamPlayersList';
import { MyTeamWithdrawButton } from 'modules/tournaments/components/BracketTournament/MyTeam/MyTeamWithdrawButton';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

interface MyTeamPlayerViewProps {
  tournament?: TournamentEntity;
}

export const MyTeamPlayerView: FC<MyTeamPlayerViewProps> = ({ tournament }) => {
  const myTeam = useSelector(currentTournamentSelector.myTeam);
  const entryFee = useSelector(currentTournamentSelector.tournamentEntryFee);
  const isSinglePlayer = useSelector(currentTournamentSelector.isSinglePlayer);

  const teamSize = useMemo(
    () => tournament?.teamsSettings?.teamSize ?? 0,
    [tournament?.teamsSettings?.teamSize]
  );

  const label = useMemo(() => {
    if (isSinglePlayer) {
      return null;
    }

    return (
      <Box>
        <TournamentSettingsTitle>Your Team</TournamentSettingsTitle>
        <Typography mb={2}>{myTeam?.name}</Typography>
      </Box>
    );
  }, [isSinglePlayer, myTeam?.name]);

  return (
    <>
      {label}
      <Box>
        <TournamentSettingsTitle>Active Players</TournamentSettingsTitle>
        {Boolean(entryFee) && (
          <Typography mb={2} variant="subtitle2" color="primary.light">
            Required to pay entry fee. Only active players at the start of the tournament are
            eligible for payouts.
          </Typography>
        )}
        <MyTeamPlayersList players={myTeam?.players ?? []} teamSize={teamSize} />
      </Box>
      <Box mt={2}>
        <MyTeamWithdrawButton tournamentId={tournament?.id} />
      </Box>
    </>
  );
};
